<template>
  <v-card class="mt-3">
    <v-card-title class="title">
      Company Culture
      <v-spacer />
      <v-dialog v-model="editing" max-width="600px" v-if="edit">
        <v-btn color="secondary darken-2" slot="activator">
          <v-icon left>mdi-pencil</v-icon> Edit
        </v-btn>
        <v-card>
          <v-card-title class="headline">
            Edit Company Culture
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid" @submit.prevent="submit">
              <v-textarea
                label="Company Culture"
                v-model="culture"
                :rules="rules.culture" required
                :error-messages="errors.culture || []"
                rows="10"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn flat @click="cancel">
              Cancel
            </v-btn>
            <v-btn :color="valid ? 'success' : 'error'" :disabled="!valid" @click="submit">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-title>
    <v-card-text v-if="organization && organization.culture">
      <markdown class="markdown" :html="false" :source="organization.culture" />
    </v-card-text>
    <v-alert v-else type="warning" :color="themes.client.light.warning" class="grey--text text--darken-4" :value="true">
      Please provide an organization culture.
    </v-alert>
  </v-card>
</template>

<script>
import Markdown from 'vue-markdown'

export default {
  components: {
    Markdown
  },
  props: { organization: Object, edit: Boolean },
  data() {
    return {
      editing: false,
      valid: false,
      rules: {
        culture: [v => !!v || 'must be specified']
      },
      errors: {},
      modified: Object.assign({}, this.organization),
      culture: this.organization.culture
    }
  },
  methods: {
    cancel() {
      this.culture = this.organization.culture
      this.editing = false
      this.errors = {}
    },
    submit() {
      if (this.valid) {
        this.modified.culture = this.culture
        this.update()
      }
    },
    update() {
      this.$store
        .dispatch('client/organization/update', this.modified)
        .then(errors => {
          if (errors) {
            this.errors = errors
            this.$store.dispatch(
              'snackbarError',
              'There was a problem saving the culture'
            )
          } else {
            this.$store.dispatch(
              'snackbarSuccess',
              'The culture was saved successfully'
            )
            this.editing = false
          }
        })
    }
  }
}
</script>
